// Shared by the Tenants page and the tenant's own report

// A kiosk's since as the API sends it (midnight UTC of the day) as
// "YYYY-MM-DD", or null for a kiosk that counts all its payments
export const sinceDay = (since) => (since ? String(since).slice(0, 10) : null);

export const money = (value) => `${new Intl.NumberFormat("mn-MN").format(value || 0)} ₮`;

export const count = (value) => new Intl.NumberFormat("mn-MN").format(value || 0);
